import { Component } from '@angular/core';
import { PaymentRequestEndpoint } from '@dato-proxy/endpoints/paymentrequest.endpoint';
import { PaymentRequest } from '@dato-proxy/entities/paymentrequest.entity';
import { EnumPaymentRequestTypes } from '@dato-proxy/enums';
import { ConfirmPaymentRequestParams } from '@dato-proxy/params/confirmpaymentrequest.param';
import { PaymentRequestResponseParams } from '@dato-proxy/params/paymentrequestresponse.param';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseEntity, BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { Globals } from 'projects/dato/_globals';

class State extends BaseState {
    IsSucceedPayment: boolean;
    ErrorMessage: string;
    PaymentRequest: PaymentRequest;
    Options = Globals.SystemOption;
    CustomerCardNumber: string;
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-payment-result',
    templateUrl: './payment-result.component.html',
    styleUrls: ['./payment-result.component.scss']
})
export class PaymentResultComponent extends BasePageComponent<BaseEntity, State> {

    constructor(A: ServiceBagService,
        private paymentRequestEndpoint: PaymentRequestEndpoint) {
        super(A, 'PaymentResultComponent', BaseEntity, State);
    }

    protected override OnInitComponent(): void {
        const paymentRequestID = this.QueryParams?.PrivateRequestID;
        if (!paymentRequestID) {
            this.State.IsSucceedPayment = false;
            return;
        }
        this.ConfirmPaymentRequest(paymentRequestID);
    }

    private ConfirmPaymentRequest(privateRequestID: string) {
        const params = new ConfirmPaymentRequestParams();
        params.PrivateID = privateRequestID;

        this.Do(this.paymentRequestEndpoint.Confirm(params), false, (response: PaymentRequestResponseParams) => {
            this.State.CustomerCardNumber = response.CreditCardNumber;
            this.SetPaymentRequest(privateRequestID);
        }, (response) => {
            this.State.IsSucceedPayment = false;
            this.State.ErrorMessage = response.ResponseMessage;
        });
    }

    private SetPaymentRequest(paymentRequestID: string) {
        this.paymentRequestEndpoint.GetPaymentRequest(paymentRequestID).subscribe(response => {
            if (!response.IsSuccess) {
                this.State.IsSucceedPayment = false;
                this.State.ErrorMessage = response.ResponseMessage;
                return;
            }
            this.State.IsSucceedPayment = true;
            this.State.PaymentRequest = response.Entity;
        });
    }

    GetPaymentMethod() {
        switch (this.State.PaymentRequest.Type) {
            case EnumPaymentRequestTypes.PaymentByExistingCard:
            case EnumPaymentRequestTypes.PaymentByNewCard:
                const creditCardNumber = this.State.CustomerCardNumber || this.State.PaymentRequest?.CreditCardNumber;
                return creditCardNumber ? `****${creditCardNumber}` : this.RC('lblCreditCard');
            case EnumPaymentRequestTypes.Paypal: return this.RC('lblPaypal');
            case EnumPaymentRequestTypes.Bit: return this.RC('lblBit');
        }
    }

    OnSeeAdditional() {
        if (!this.IsAllowAccounting()) return;
        this.Navigate(['/pages/reports']);
    }

    IsAllowAccounting() {
        return Globals.IsAllowAccounting();
    }

}
